import React from "react";
import { Box, Button, Stack } from "@mui/material";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import FolderSpecialRoundedIcon from "@mui/icons-material/FolderSpecialRounded";
import { useSearchParams } from "react-router-dom";
import OwnerClientsPage from "./OwnerClientsPage";
import OwnerProjectsPage from "./OwnerProjectsPage";

export default function OwnerCrmPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("vista") === "proyectos" ? "proyectos" : "clientes";
  const setView = (next) => { const params = new URLSearchParams(searchParams); if (next === "proyectos") params.set("vista", "proyectos"); else params.delete("vista"); params.delete("cliente"); setSearchParams(params, { replace: true }); };
  return <Box sx={{ width: "100%", minHeight: 0 }}>
    <Stack direction="row" spacing={.5} sx={{ mb: .7 }}>
      <Button size="small" variant={view === "clientes" ? "contained" : "text"} startIcon={<GroupsRoundedIcon />} onClick={() => setView("clientes")} sx={{ textTransform: "none", fontWeight: 950 }}>Clientes</Button>
      <Button size="small" variant={view === "proyectos" ? "contained" : "text"} startIcon={<FolderSpecialRoundedIcon />} onClick={() => setView("proyectos")} sx={{ textTransform: "none", fontWeight: 950 }}>Proyectos</Button>
    </Stack>
    {view === "clientes" ? <OwnerClientsPage /> : <OwnerProjectsPage />}
  </Box>;
}
